<template>
  <path
    d="M11.19 1.36024L4.19 4.47024C3.47 4.79024 3 5.51024 3 6.30024V11.0002C3 16.5502 6.84 21.7402 12 23.0002C17.16 21.7402 21 16.5502 21 11.0002V6.30024C21 5.51024 20.53 4.79024 19.81 4.47024L12.81 1.36024C12.3 1.13024 11.7 1.13024 11.19 1.36024ZM9.29 16.2902L6.7 13.7002C6.31 13.3102 6.31 12.6802 6.7 12.2902C7.09 11.9002 7.72 11.9002 8.11 12.2902L10 14.1702L15.88 8.29024C16.27 7.90024 16.9 7.90024 17.29 8.29024C17.68 8.68024 17.68 9.31024 17.29 9.70024L10.7 16.2902C10.32 16.6802 9.68 16.6802 9.29 16.2902Z"
  />
</template>
